import axios from "axios"
import { API_BASE_URL } from "../config"

export const getManageEstateList = async (mode: number = 0) => {
  for (let i = 0; i < 3; i++) {
    try {
      const response = await axios.post(`${API_BASE_URL}/estate/list`, {
        session_code: localStorage.getItem("session_code"),
        mode: mode
      })

      return response.data
    } catch (error: any) {
      if (error.code && error.code == "ERR_NETWORK" && i != 2) {
        continue
      }
      throw error
    }
  }
}
